import React from 'react'

import SettingsPage from '../SettingsPage'
import ExternalChannelsTable from './ExternalChannelsTable'

const ExternalChannelsSettings = () => {
  return (
    <SettingsPage title='External Channels'>
      <ExternalChannelsTable />
    </SettingsPage>
  )
}

export default ExternalChannelsSettings
